import React, { useState, useEffect, use } from 'react';
import '../styles/global.css';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { CircularProgress } from '@mui/material';
import MenuAssociados from '../components/MenuAssociados';

function Contatos() {
    const navigate = useNavigate();
    const [menuAberto, setMenuAberto] = useState(false);
    const associado = parseInt(sessionStorage.getItem('pesAssociado'));
    const loggedIn = sessionStorage.getItem('loggedIn');
    const [isLoadingMOD, setIsLoadingMOD] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectStatus, setSelectStatus] = useState('');
    const [contatos, setContatos] = useState([]);

    function handleNovoContato() {
        navigate('/Contato');
    }

    useEffect(() => {
        if (loggedIn === false || loggedIn === null || loggedIn === undefined)
        {
            navigate('/Login');
            window.location.reload();
        }
    }, []);
    
    const toggleMenu = () => {
        setMenuAberto(!menuAberto);
    };

    const toggleLogoff = () => {
        localStorage.clear();
        localStorage.setItem('loggedIn', false);
        localStorage.removeItem('user');
        sessionStorage.clear();
        
        navigate('/');
        window.location.reload();
    };

    useEffect(() => {
        setIsLoadingMOD(true);
        var token = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";

        axios
        .get(process.env.REACT_APP_API_URL + '/routes.php?metodo=obterContatos',
            {
                headers: {
                "X-Access-Token": token,
                "Content-Type": "application/json; charset=UTF-8"
                }
            }
        )
        .then(response => {
            //console.log(response.data); return;
            setContatos(response.data);
            setIsLoadingMOD(false);
        })
        .catch(error => {
            console.error('Erro ao buscar contatos:', error);
            setIsLoadingMOD(false);
        });
    }, []);


  //salvar log de navegação
  useEffect(() => {
    const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
    const log = {
      IdPessoa: sessionStorage.IdPessoa ? sessionStorage.IdPessoa : 0,
      logTipo: "Navegação",
      logModulo: "Página de Contatos",
      logCriadoPor: sessionStorage.nomeUsuario ? sessionStorage.nomeUsuario : "Visitante",
      logCriadoEm: new Date().toISOString(),
      logCodigoGUID: crypto.randomUUID()
    };
    axios                    
      .post(process.env.REACT_APP_API_URL 
          + '/routes.php?metodo=novoLog', 
          log, {
              headers: {
                  "X-Access-Token" : tokenAPI,
                  "Content-Type": "application/json; charset=UTF-8"
              }
          }
      )
      .then(response => {
          //console.log(response.data[0].mensagem);
      })
      .catch(error => {
          console.error('Erro ao enviar log:', error);
      });
  }, []);

  //identificar a resolução da tela para ajustar o tamanho da tabela
      const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  
      useEffect(() => {
          const handleResize = () => {
          setWindowWidth(window.innerWidth);
          };
  
          window.addEventListener('resize', handleResize);
  
          return () => {
          window.removeEventListener('resize', handleResize);
          };
      }, []);

  return (
    <div style={{ paddingBottom: '80px' }}>
        <main>
            <div>
                {/* Menu de navegação */}
                <MenuAssociados />
                {/* Titulos da página */}
                <div className='headerMain'>
                    <label className='labelTitulo' >CONTATOS GERAIS</label>
                    <label className='labelSubTitulo'>Registros do Form de Contato</label>
                </div>
                
                {/* Pesquisa filtro e Novo */}
                <div className='containerBarraPesquisa'>
                    {/* pesquisa por texto no mes e ano */}
                    <input className='inputBarraPesquisa'
                    placeholder='PESQUISAR'
                    type='text'
                    id='inputPesquisa'
                    name='inputPesquisa'
                    onChange={event => {
                    setSearchTerm(event.target.value)
                    }}
                    />
                    
                </div>
                {/* Conteúdo da página */}  
                <div className='tabelaPadrao'>
                    {windowWidth < 769 ? (
                        isLoadingMOD ? 
                        <tr>
                            <td colSpan="3" style={{ width: "100%", textAlign: "center"}}>
                                <CircularProgress />
                            </td>
                        </tr>
                        : 
                        contatos
                        .filter(val => {
                            const searchLower = searchTerm.toLowerCase();
                            return (
                                val.cntNome.toLowerCase().includes(searchLower)
                                ||val.cntEmail.toLowerCase().includes(searchLower)
                                ||val.cntMensagem.toLowerCase().includes(searchLower)
                                ||val.cntCriadoEm.toLowerCase().includes(searchLower)
                            );
                        })
                        .map((contato) => (
                            <div style={{borderBottom: '1px solid #ccc', margin: '10px', backgroundColor: '#dfdada', borderRadius: '5px', padding: '10px' }}>
                                <div key={contato.IdContato} onClick={() => navigate(`/Contato/${contato.IdContato}`)} style={{cursor: 'pointer'}} className='p2'>
                                    <p style={{ color: '#000' }}><b>NOME: </b> {contato.cntNome}</p>
                                    <p style={{ color: '#000', marginTop: '10px' }}><b>EMAIL: </b> {contato.cntEmail}</p>
                                    <p style={{ color: '#000', marginTop: '10px' }}><b>DATA: </b> {contato.cntCriadoEm}</p>
                                    <p style={{ color: '#000', marginTop: '10px' }}><b>MENSAGEM: </b> {contato.cntMensagem}</p>
                                    <p style={{ color: contato.cntLidaEm !== '' ? 'green' : 'red', marginTop: '10px' }}><b>LIDA: {contato.cntLidaEm !== '' ? 'Sim' : 'Não'} - {contato.cntLidaEm !== '' ? contato.cntLidaEm : ''} - {contato.cntLidaPor !== '' ? contato.cntLidaPor : ''}</b></p>
                                </div>
                            </div>
                            ))
                    ) : (
                    <table>
                        <thead>
                            <tr>
                                <th className='tdAlignCenter'>ID</th>
                                <th className='tdAlignLeft'>REMETENTE</th>
                                <th className='tdAlignLeft'>MENSAGEM</th>
                                <th className='tdAlignCenter'>LIDA</th>
                            </tr>
                        </thead>
                        <tbody>
                            {isLoadingMOD ? 
                                <tr>
                                    <td colSpan="3" style={{ width: "100%", textAlign: "center"}}>
                                        <CircularProgress />
                                    </td>
                                </tr>
                                : 
                                contatos.length === undefined ?
                                <tr>
                                    <td colSpan="3" style={{ width: "100%", textAlign: "center"}}>
                                        Nenhum contato encontrado.
                                    </td>
                                </tr>
                                :
                                contatos
                                .filter(val => {
                                    const searchLower = searchTerm.toLowerCase();
                                    return (
                                        val.cntNome.toLowerCase().includes(searchLower)
                                        ||val.cntEmail.toLowerCase().includes(searchLower)
                                        ||val.cntMensagem.toLowerCase().includes(searchLower)
                                        ||val.cntCriadoEm.toLowerCase().includes(searchLower)
                                    );
                                })
                                .map((contato) => (
                                    <tr style={{cursor: 'pointer'}} key={contato.IdContato} onClick={() => navigate(`/Contato/${contato.IdContato}`)}>
                                        <td className='tdAlignCenter'>{contato.IdContato}</td>

                                        <td>{contato.cntNome}<br></br>
                                        <span style={{ fontSize: '0.8em', color: '#888', textTransform: 'lowercase' }}>{contato.cntEmail}</span></td>
                                        
                                        <td>{contato.cntCriadoEm}<br></br>
                                        <span style={{ fontSize: '0.8em', color: '#888', textTransform: 'lowercase' }}>{contato.cntMensagem}</span></td>
                                        
                                        <td width={40} className='tdAlignCenter'>
                                            <input
                                            type="checkbox"
                                            checked={contato.cntLidaEm !== '' ? true : false}
                                            className='checkboxCenter'
                                            readOnly
                                            />
                                        </td> 
                                    </tr>
                                    ))
                            }
                        </tbody>
                    </table>
                    ) }
                </div>
            </div>
        </main>
    </div>
  );
}

export default Contatos;